type Link = {
    link: HTMLAnchorElement
    key: string
    value: string
}

type Item = {
    item: HTMLLIElement
    branche: string
    solutions: string
}

class NewsList {
    root: HTMLDivElement
    filterRoot: HTMLDivElement
    filterClearLink: HTMLAnchroElement
    uid: string
    links: Link[] = []
    items: Item[] = []
    filters: { [key: string]: string[] } = {}

    constructor(rootEl) {
        if (!rootEl.hasAttribute('data-list')) {
            return
        }

        const uid = rootEl.getAttribute('data-list')
        const filterEl = document.querySelector(`.news-list-filters[data-for="${uid}"]`)

        if (!filterEl) {
            throw new Error(`not new-list-filters element found for uid ${uid}`)
        }

        this.root = rootEl
        this.uid = uid.replace('news-list-', '')
        this.filterRoot = filterEl

        this.initFilters()

        this.readHash()
        window.addEventListener('hashchange', () => this.readHash())
    }

    private initFilters() {
        this.filterRoot.querySelectorAll('a').forEach(link => {
            if (!link.hasAttribute('data-filter-key') || !link.hasAttribute('data-filter-value')) {
                return
            }

            const key = link.getAttribute('data-filter-key')
            const value = link.getAttribute('data-filter-value')

            this.links.push({
                link,
                key,
                value,
            })

            link.addEventListener('click', () => this.toggleHash(key, value))
        })

        this.filterClearLink = this.filterRoot.querySelector('a.clear-filters')

        this.filterClearLink.addEventListener('click', () => {
            this.filters = {}
            this.updateHash()
        })

        this.root.querySelectorAll('li.item').forEach(item => {
            const data = Array.from(item.classList)
                .filter(c => c.substring(0, 5) === 'term-')
                .map(c => c.substring(5).split('-'))
                .reduce((res, chunks) => {
                    const key = chunks.shift()
                    const value = chunks.join('-')
                    if (typeof res[key] === 'undefined') {
                        res[key] = []
                    }
                    res[key].push(value)
                    return res
                }, {})

            this.items.push({
                item,
                branche: typeof data['branche'] !== 'undefined' ? data['branche'] : [],
                solutions: typeof data['solutions'] !== 'undefined' ? data['solutions'] : [],
            })
        })
    }

    private toggleHash(key: string, value: string) {
        if (typeof this.filters[key] === 'undefined') {
            this.filters[key] = []
        }

        if (this.filters[key].includes(value)) {
            this.filters[key] = this.filters[key].filter(v => v !== value)

            if (this.filters[key].length === 0) {
                delete this.filters[key]
            }
        } else {
            this.filters[key].push(value)
        }

        this.updateHash()
    }

    private updateHash() {
        let hash = (location.hash || '')
        if (hash.substring(0, 1) === '#') {
            hash = hash.substring(1)
        }

        let hashData = hash.split(',').reduce((res, item) => {
            const [key, value] = item.split('=')

            if (key.substring(0, this.uid.length + 4) !== `nlf-${this.uid}`) {
                res[key] = value
            }

            return res
        }, {})

        for (const key in this.filters) {
            hashData[`nlf-${this.uid}-${key}`] = this.filters[key].join('|')
        }

        const newHash = Object.keys(hashData).reduce((res, key) => {
            if (key && typeof hashData[key] !== 'undefined') {
                res.push(`${key}=${hashData[key]}`)
            }
            return res
        }, []).join(',')

        location.hash = newHash ? newHash : 'default'
    }

    private readHash(e) {
        let hash = (location.hash || '')
        if (hash.substring(0, 1) === '#') {
            hash = hash.substring(1)
        }

        let hashData = hash.split(',').reduce((res, item) => {
            const [key, value] = item.split('=')

            if (key.substring(0, this.uid.length + 4) === `nlf-${this.uid}`) {
                res[key] = value
            }

            return res
        }, {})

        this.filters = {}
        for (const key in hashData) {
            const type = key.substring(this.uid.length + 5)
            const values = hashData[key].split('|')
            this.filters[type] = values
        }

        this.links.forEach((link: Link) => {
            if (typeof this.filters[link.key] === 'undefined' || !this.filters[link.key].includes(link.value)) {
                link.link.classList.remove('active')
            } else {
                link.link.classList.add('active')
            }
        })

        const hasFilters = Object.keys(this.filters).length > 0

        const filterKeys = this.convertToKeys(this.filters)

        this.items.forEach((item: Item) => {
            if (!hasFilters) {
                item.item.classList.remove('hidden')
                return
            }

            const keys = this.convertToKeys({
                branche: item.branche,
                solutions: item.solutions,
            })

            let isVisible = false
            for (const key of filterKeys) {
                if (keys.includes(key)) {
                    isVisible = true
                    break
                }
            }

            if (isVisible) {
                item.item.classList.remove('hidden')
            } else {
                item.item.classList.add('hidden')
            }
        })

        if (Object.keys(this.filters).length) {
            this.filterClearLink.classList.add('visible')
        } else {
            this.filterClearLink.classList.remove('visible')
        }
    }

    private convertToKeys(obj: { [key: string]: string[] }) {
        const res = []
        for (const key in obj) {
            for (const value of obj[key]) {
                res.push(`${key}-${value}`)
            }
        }
        return res
    }
}

window.addEventListener('load', () => {
    document.querySelectorAll('.news-list').forEach(rootEl => {
        try {
            new NewsList(rootEl)
        } catch (err) {
            console.error(err)
        }
    })
})
